module.exports = __webpack_public_path__ + "static/media/21.40cd5440.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/21.png
// module id = 1395
// module chunks = 0